import { Injectable } from '@angular/core';
import { clone } from 'lodash-es';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { select, Store } from '@ngrx/store';
import { AppState } from '../reducers';
import { HttpUtilsService } from '../_base/crud';
import { currentAuthToken, currentUser } from '../auth';
import { BehaviorSubject, Observable, of } from 'rxjs';

export interface ActiveSession {
  contact_id: number;
  contact_name: string;
  username: string;
  created: string;
}

@Injectable({
  providedIn: 'root',
})
export class FilteredViewService {
  private filteredObject: any = {};
  private authToken;
  private companyId;
  private trackerToken: string;
  private filteredViewId: number;
  public isFilterView: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private relatedFilter: any = [];
  private allRelated: any = [];

  constructor(
    private http: HttpClient,
    private httpUtils: HttpUtilsService,
    private store: Store<AppState>,
  ) {
    this.store.pipe(select(currentAuthToken)).subscribe((res) => (this.authToken = res));
    this.store.pipe(select(currentUser)).subscribe((res) => (this.companyId = res.companyID));
  }

  getFilteredObject() {
    return clone(this.filteredObject);
  }

  setFilteredObject(filteredObject) {
    this.filteredObject = filteredObject;
  }

  getRelatedFilter() {
    return clone(this.relatedFilter);
  }

  setRelatedFilter(relatedFilter) {
    this.relatedFilter = relatedFilter;
  }

  setAllRelatedFilter(related: any) {
    this.allRelated = related;
  }

  getAllRelatedFilter() {
    return clone(this.allRelated);
  }

  createdFilteredViewSession() {
    const url = `${environment.TRACKER_BASE}/companies/${this.companyId}/sessions`;
    const body = this._getFilteredViewBody();
    return this.http.post<any>(url, body, { observe: 'response' });
  }

  private _getFilteredViewBody() {
    return {
      session_type: this.filteredObject.sessionType,
      filter_type: this.filteredObject.filterType,
      contact_id: this.filteredObject.contact.id,
      filters: this.filteredObject.selectedFilter,
      call_id: this.filteredObject.callId,
    };
  }

  setTrackerToken(trackerToken: string) {
    this.trackerToken = trackerToken;
  }

  getTrackerToken() {
    return this.trackerToken;
  }

  setFilteredViewId(id) {
    this.filteredViewId = id;
  }

  closeCurrentFilteredView(closingBody: { call_note: any; status: any }) {
    const url = `${environment.TRACKER_BASE}/companies/${this.companyId}/sessions/${this.filteredViewId}/close`;
    return this.http.put<any>(url, closingBody, {});
  }

  getFilteredViewId() {
    return this.filteredViewId;
  }

  getAllPatients(entityIds, type) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    let filter = '';
    if (type === 'DOCTOR') {
      entityIds.forEach((element) => (filter = filter + '&doctor_id=' + element));
    }
    if (type === 'FACILITY') {
      entityIds.forEach((element) => (filter = filter + '&facility_id=' + element));
    }
    if (type === 'PATIENT') {
      entityIds.forEach((element) => (filter = filter + '&id=' + element));
    }
    const url =
      environment.CORE_BASE +
      `/companies/${this.companyId}/patients?page=0&size=10000&is_active=true` +
      filter;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getAllContacts(entityIds) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    let filter = '';
    entityIds.forEach((element) => (filter = filter + '&related_id=' + element));
    const url =
      environment.CORE_BASE +
      `/companies/${this.companyId}/contacts?page=0&size=10000&is_active=true` +
      filter;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getSessionById(id) {
    const httpHeaders = this.httpUtils.getHTTPHeaders(this.authToken);
    const url = environment.TRACKER_BASE + `/companies/${this.companyId}/sessions/` + id;
    return this.http.get<any>(url, { headers: httpHeaders });
  }

  getActiveSessions(contactIds: number[]): Observable<ActiveSession[]> {
    let fromString = 'ended=false';

    contactIds.forEach((id) => (fromString += `&contact_id=${id}`));
    const params = new HttpParams({ fromString });

    return this.http.get<ActiveSession[]>(
      `${environment.TRACKER_BASE}/companies/${this.companyId}/sessions`,
      { params },
    );
  }

  getRecentSessions(user, page: number, size: number, entity: any) {
    if (!user) {
      return of([]);
    }
    let _entity = '';
    if (entity && entity.id) {
      const entityType = Object.prototype.hasOwnProperty.call(entity, 'contact_id')
        ? 'CONTACT'
        : entity.entity_type;
      _entity = '&entity_type=' + entityType + '&entity_id=' + entity.id;
    }
    const url =
      environment.TRACKER_BASE +
      `/companies/${this.companyId}/recent?&sort=created,desc&page=${page}&size=${size}${_entity}&user_id=` +
      user.id;
    return this.http.get<any>(url);
  }

  createRecentSession(body) {
    const url = `${environment.TRACKER_BASE}/companies/${this.companyId}/recent`;
    return this.http.post<any>(url, body);
  }
}
